// extracted by mini-css-extract-plugin
export default {"root":"styles_root__QNThl","title":"styles_title__WjHww","FormWrapper":"styles_FormWrapper__IKFq-","map":"styles_map__lXUoB","phoneWrapper":"styles_phoneWrapper__dUwaC"};